const IMAGES = [
  {
    img: require('./serti1.webp')
  },
  {
    img: require('./serti2.webp')
  },
  {
    img: require('./serti3.webp')
  },
  {
    img: require('./serti4.webp')
  },
  {
    img: require('./serti5.webp')
  },
  {
    img: require('./serti6.webp')
  },
  {
    img: require('./serti7.webp')
  },
  {
    img: require('./serti8.webp')
  },
  {
    img: require('./serti9.webp')
  },
]

export default IMAGES;